;(function($) {

  function minakiQuantity() {
    this.$cart = $('#cart');
    this.$items = this.$cart.find('.minaki-cart-items');
    this.data = null;
    this.init();
  }

  minakiQuantity.prototype = {
    init() {
      const self = this;
      this.$items.each(function() {
        const $self = $(this);
        const $cartCountBubble = $('.cart-count-bubble').find('span[aria-hidden]');
        const $quantity = $self.find('.quantity');
        const $input = $quantity.find('.quantity-input');
        const $minus = $quantity.find('button[name="minus"]');
        const $plus = $quantity.find('button[name="plus"]');
        const itemId = $self.find('input[name="itemId"]').val();
        const inventoryQuantity = $self.data('inventory-quantity');
        const dataMax = $input.data('quantity');
        const $deleteLink = $self.find('.delete .button--tertiary');

        const giftbagId = 49836735201494;
        const noshiId = 49836652921046;

        let dataQuantity = $input.data('quantity');
        let currentQuantity = Number($input.val() || dataQuantity);
        let maxNum = 10;
        const isOption = ($self.data('index') == 9999 || $self.data('index') == 9998);
        if (!isOption && dataMax) {
          maxNum = dataMax;
        }
        if (inventoryQuantity && inventoryQuantity <= maxNum) {
          maxNum = inventoryQuantity;
        }
        if (currentQuantity >= maxNum) {
          $plus.prop('disabled', true);
        }
        if (currentQuantity <= 1) {
          $minus.prop('disabled', true);
        }

        $minus.on('click', function(e) {
          let current = Number(($input.val() || $input.data('quantity')));
          let minus = current;
          if (minus <= 1) {
            minus = 1;
          } else {
            minus--;
          }
          if (minus <= 1) {
            $(this).prop('disabled', true);
          } else {
            $(this).prop('disabled', false);
            $plus.prop('disabled', false);
          }
          $input.val(minus);
          $input.data('quantity', minus).text(minus);
          $input.change();
        });

        $plus.on('click', function(e) {
          let current = Number(($input.val() || $input.data('quantity')));
          let plus = current;
          if (plus >= maxNum) {
            plus = maxNum;
          } else {
            plus++;
          }
          if (plus >= maxNum) {
            $(this).prop('disabled', true);
          } else {
            $(this).prop('disabled', false);
            $minus.prop('disabled', false);
          }
          $input.val(plus);
          $input.data('quantity', plus).text(plus);
          $input.change();
        });

        $input.on('change.quantity', function(e) {
          const $selfInput = $(this);
          if (($selfInput.val() || $selfInput.data('quantity')) > maxNum) {
            $selfInput.val(maxNum);
            $selfInput.data('quantity', maxNum).text(maxNum);
            return;
          }
          if (($selfInput.val() || $selfInput.data('quantity')) >= maxNum) {
            $plus.prop('disabled', true);
          } else {
            $plus.prop('disabled', false);
          }
          $('.update-loading').addClass('enable');
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: itemId,
              quantity: Number($selfInput.val() || $selfInput.data('quantity'))
            })
          })
          .then(response => response.json())
          .then(function(data) {
            $('.update-loading').removeClass('enable');
            if (($selfInput.val() || $selfInput.data('quantity')) == 0) {
              if (itemId != giftbagId && itemId != noshiId) {
                $self.remove();
                $cartCountBubble.attr('aria-hidden', true);
              }
              if (itemId == giftbagId) {
                $('#cartGiftbag').find('.minaki-cart-items').hide();
              }
              if (itemId == noshiId) {
                $('#cartNoshi').find('.minaki-cart-items').hide();
              }
            }
            if (self.$cart.find('.minaki-cart-items').length < 1) {
              $('.minaki-cart').addClass('is-empty');
              return;
            }
            self.calc();
          })
          .catch(function(error) {
            $('.update-loading').removeClass('enable');
            console.error('Error:', error);
          });
        });

        $deleteLink.on('click', function(e) {
          e.preventDefault();
          $input.val(0);
          $input.data('quantity', 0).text(0);
          $input.change();

          if (itemId == giftbagId) {
            const $giftbag_radio = $('#cartGiftbag').find('input[name="cart_giftbag"]');
            $giftbag_radio.each(function () {
              $(this).prop('checked', false);
              if ($(this).val() == 'none') {
                $(this).prop('checked', true);
              }
            });
          }
          if (itemId == noshiId) {
            const $noshi_radio = $('#cartNoshi').find('input[name="cart_noshi"]');
            $noshi_radio.each(function () {
              $(this).prop('checked', false);
              if ($(this).val() == 'none') {
                $(this).prop('checked', true);
              }
            });
          }
        });
      });
    },

    calc() {
      const $cartCountBubble = $('.cart-count-bubble').find('span[aria-hidden]');
      const $total_item_count = $('#total_item_count');
      const $total_price_subtotal = $('#total_price_subtotal');
      const $total_price_tax = $('#total_price_tax');
      const $total_price_original = $('#total_price_original');

      function moneySlice(num) {
        return num.toString(10).slice(0, -2);
      }

      $.getJSON('/cart.js')
      .done((data) => {
        BigNumber.config({
          ROUNDING_MODE: BigNumber.ROUND_HALF_UP,
          DECIMAL_PLACES: 0
        });
        const formatter = new Intl.NumberFormat('ja-JP');
        function moneyFormat(num) {
          return '&yen;' + formatter.format(num);
        }
        $total_item_count.text(data.item_count);
        var divided = new BigNumber(moneySlice(data.items_subtotal_price));
        var subtotal = divided.div(1.1).dp(0, 5);
        $total_price_subtotal.html(moneyFormat(subtotal));
        var total = data.total_price;
        var consTimes = new BigNumber(moneySlice(total));
        var cons = consTimes.minus(subtotal);
        $total_price_tax.html(moneyFormat(cons));
        $total_price_original.html(moneyFormat(moneySlice(total)));
        $cartCountBubble.text(data.item_count).attr('aria-hidden', false);
      });
    },

    plus() {},
    minus() {},
  };

  const quantityChange = new minakiQuantity();


  function minakiGiftbag() {
    this.$giftbag = $('#cartGiftbag');
    this.init();
  }

  minakiGiftbag.prototype = {
    init() {
      const self = this;
      const giftbagId = 49836735201494;
      this.$giftbag.find('input[name="cart_giftbag"]').on('change', function (e) {
        $('.update-loading').addClass('enable');
        const $self = $(this);
        if ($self.val() === 'add') {
          self.add(giftbagId, 1);
        } else if ($self.val() === 'none') {
          self.change(giftbagId, 0);
        }
      });
    },

    add(itemId, quantity) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: itemId, quantity: quantity }] })
      })
      .then(response => response.json())
      .then(function(data) {
        $('.update-loading').removeClass('enable');
        $('#cartGiftbag').find('.minaki-cart-items .quantity-input').val(quantity).text(quantity);
        $('#cartGiftbag').find('.minaki-cart-items').show();
        quantityChange.calc();
      })
      .catch(function(error) {
        $('.update-loading').removeClass('enable');
        console.error('Error:', error);
      });
    },

    change(itemId, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemId, quantity: quantity })
      })
      .then(response => response.json())
      .then(function(data) {
        $('.update-loading').removeClass('enable');
        $('#cartGiftbag').find('.minaki-cart-items .quantity-input').val(quantity).text(quantity);
        $('#cartGiftbag').find('.minaki-cart-items').hide();
        quantityChange.calc();
      })
      .catch(function(error) {
        $('.update-loading').removeClass('enable');
        console.error('Error:', error);
      });
    }
  };

  const addGiftbag = new minakiGiftbag();


  function minakiNoshi() {
    this.$noshi = $('#cartNoshi');
    this.init();
  }

  minakiNoshi.prototype = {
    init() {
      const self = this;
      const noshiId = 49836652921046;
      this.$noshi.find('input[name="cart_noshi"]').on('change', function (e) {
        $('.update-loading').addClass('enable');
        const $self = $(this);
        if ($self.val() === 'add') {
          self.add(noshiId, 1);
        } else if ($self.val() === 'none') {
          self.change(noshiId, 0);
        }
      });
    },

    add(itemId, quantity) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: itemId, quantity: quantity }] })
      })
      .then(response => response.json())
      .then(function(data) {
        $('.update-loading').removeClass('enable');
        $('#cartNoshi').find('.minaki-cart-items .quantity-input').val(quantity).text(quantity);
        $('#cartNoshi').find('.minaki-cart-items').show();
        quantityChange.calc();
      })
      .catch(function(error) {
        $('.update-loading').removeClass('enable');
        console.error('Error:', error);
      });
    },

    change(itemId, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemId, quantity: quantity })
      })
      .then(response => response.json())
      .then(function(data) {
        $('.update-loading').removeClass('enable');
        $('#cartNoshi').find('.minaki-cart-items .quantity-input').val(quantity).text(quantity);
        $('#cartNoshi').find('.minaki-cart-items').hide();
        quantityChange.calc();
      })
      .catch(function(error) {
        $('.update-loading').removeClass('enable');
        console.error('Error:', error);
      });
    }
  };

  const addNoshi = new minakiNoshi();


  function minakiDelivery() {
    this.$target = $('#cartCalendar');
    this.$calendarData = this.$target.find('.cart-calendar__data');
    this.flatpickr_instance = null;
    this.init();
  }

  minakiDelivery.prototype = {
    init() {
      this.$calendarData.hide();
      this.flatpickr();
      this.deliveryCheck();
      this.dateOutput();
      this.timeOutput();
      this.checkout();
    },

    checkout() {
      const self = this;
      const $formCart = $('#cart');
      $formCart.on('submit', function (e) {
        e.preventDefault();
        const $self = $(this);
        const $radioWrap = self.$target.find('.cart-calendar-radio');
        const $radio = $radioWrap.find('input[type="radio"]');
        if ($radio.eq(1).prop('checked')) {
          if ($('#pickerDate').val() === '') {
            alert('配送希望日を選択してください');
            return false;
          }
        }
        $self.attr('action', '/checkout');
        $self[0].submit();
      });
    },

    updateCart() {
      function timeValue() {
        var time = $('.delivery-time input[type="radio"]');
        var val = '';
        time.each(function () {
          if ($(this).prop('checked')) {
            val = $(this).val();
          }
        });
        return val;
      }
      var attributes = {
        attributes: {
          '配送指定': $('.cart-calendar-radio input[type="radio"]:checked').val(),
          '配送希望日': $('#pickerDate').val(),
          '配送希望時間帯': timeValue(),
        }
      };
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(attributes),
      })
      .then(response => response.json())
      .then(data => { console.log('Success:', data.attributes); })
      .catch(error => { console.error('Error:', error); });
    },

    flatpickr() {
      const self = this;
      let flatpickr_options = {
        'locale': 'ja',
        inline: true,
        minDate: new Date().fp_incr(7),
        maxDate: new Date().fp_incr(45),
        defaultDate: cart_inputDate,
        disable: [
          ...calendarConfig.disabledDates,
          ...calendarConfig.disabledRanges
        ]
      };
      this.flatpickr_instance = flatpickr('#pickerDate', flatpickr_options);
      this.flatpickr_instance.config.onChange.push(function (selectedDates, dateStr, instance) {
        if (dateStr !== '') {
          $('.delivery-time').addClass('active');
          var timeCheck = false;
          self.$target.find('.delivery-time input[type="radio"]').each(function () {
            if ($(this).prop('checked')) { timeCheck = true; }
          });
          if (!timeCheck) {
            self.$target.find('.delivery-time input[type="radio"]').eq(0).prop('checked', true);
            self.timeOutput();
          }
        }
      });
      if ($('#pickerDate').val() !== '') {
        self.dateOutput();
        $('.delivery-time').addClass('active');
      }
    },

    deliveryReset() {
      $('.delivery-time').removeClass('active');
      this.$calendarData.find('.cart-view-data').removeClass('active');
      $('#pickerDate').val('');
      this.flatpickr_instance.clear();
      this.$target.find('.delivery-time input[type="radio"]').each(function () {
        $(this).prop('checked', false);
      });
    },

    deliveryCheck() {
      const self = this;
      const $radioWrap = this.$target.find('.cart-calendar-radio');
      const $radio = $radioWrap.find('input[type="radio"]');
      function deliveryRender($el) {
        if ($el.prop('checked')) {
          if ($el.val() === '配送指定あり') {
            self.$calendarData.show();
          } else {
            self.$calendarData.hide();
            self.deliveryReset();
          }
        }
      }
      $radio.each(function () { deliveryRender($(this)); });
      $radio.on('change', function (e) {
        deliveryRender($(this));
        self.updateCart();
      });
    },

    dateOutput() {
      const self = this;
      const $pickerDate = $('#pickerDate');
      const $cartViewDate = $('#cartViewDate');
      function outputText($el) {
        var val = $el.val();
        if (val == '') return;
        var days = ['日', '月', '火', '水', '木', '金', '土'];
        var date = new Date(val);
        var mm = date.getMonth() + 1;
        var dd = date.getDate();
        var day = date.getDay();
        $cartViewDate.text(mm + '月' + dd + '日（' + days[day] + '）');
      }
      outputText($pickerDate);
      $pickerDate.on('input', function () {
        outputText($(this));
        self.updateCart();
      });
    },

    timeOutput() {
      const self = this;
      const $deliveryTime = this.$calendarData.find('.delivery-time');
      const $cartViewTime = $('#cartViewTime');
      function outputText($el) {
        var val = $el.val();
        if (val == '') return;
        $cartViewTime.text(val);
      }
      $deliveryTime.find('input[type="radio"]').each(function () {
        if ($(this).prop('checked')) {
          outputText($(this));
          self.$calendarData.find('.cart-view-data').addClass('active');
        }
      });
      $deliveryTime.find('input[type="radio"]').on('change input', function () {
        outputText($(this));
        self.$calendarData.find('.cart-view-data').addClass('active');
        self.updateCart();
      });
    }
  };

  const myDelivery = new minakiDelivery();
})(jQuery);